import React, { useEffect, useState } from 'react';
import bannerend from '../../assets/images/shape8.png'
import bgImg from '../../assets/images/aboutus/background_pattern.png'
import aboutimg from '../../assets/images/aboutus/travel.png'
import aboutimg1 from '../../assets/images/aboutus/travel2.png'
import location from '../../assets/images/aboutus/location.png'
import bag from '../../assets/images/aboutus/briefcase.png'
import file from '../../assets/images/aboutus/file-management.png'
import quote1 from '../../assets/images/aboutus/left.png'
import quote2 from '../../assets/images/aboutus/right.png'

import { Col, Row } from 'antd'
import { AimOutlined, CommentOutlined, CompassOutlined, FlagOutlined } from '@ant-design/icons'
import LetterPad from '../LetterPad';


const testimonials = [
  {
    name: "Venkat & Nandini,",
    position: "Chennai.",
    photo:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-0.3.5&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=200&fit=max&s=707b9c33066bf8808c934c8ab394dff6",
    text:
      "Our trip with Travelance Holidays was simply amazing! The team did a fantastic job in organizing everything – from the flights to the hotel stays. We loved exploring Singapore and enjoyed all the vibrant attractions. We definitely recommend this travel agency for an unforgettable experience!"
  },
  {
    name: "Mr. & Mrs Hari,",
    position: "Chennai",
    photo: "https://randomuser.me/api/portraits/women/44.jpg",
    text:
      "I had an incredible time in Dubai thanks to Travelance Holidays. The guided city tours were perfect, and we got to see everything from the Burj Khalifa to the luxurious shopping malls. The trip was seamless and stress-free. Highly recommend for anyone visiting Dubai!"
  },
  {
    name: "Sandeep & Family,",
    position: "Coimbatore",
    photo: "https://randomuser.me/api/portraits/women/68.jpg",
    text:
      "Travelance Holidays made our trip to Thailand unforgettable. From the beautiful beaches to the bustling markets, everything was perfectly planned. We appreciated the hassle-free transfers and the wonderful local experiences they organized. Looking forward to booking our next trip with them!"
  },
  {
    name: "Priya & Kanika",
    position: "Chennai",
    photo: "https://randomuser.me/api/portraits/women/65.jpg",
    text:
      "Bali was everything we hoped for and more, thanks to Travelance Holidays! They took care of every detail, ensuring we had the best accommodations and excursions. It was the perfect mix of relaxation and adventure. We’ll definitely be booking more trips with them!."
  },
  {
    name: "Anita & Friends",
    position: "Hyderabad",
    photo: "https://randomuser.me/api/portraits/men/43.jpg",
    text:
      "Our trip to Kashmir with Travelance Holidays was magical. The scenic beauty of the mountains, the warm hospitality, and the well-planned itinerary made this trip truly memorable. Everything was handled with care and professionalism. Highly recommended!"
  },
];


const mapping = [{
  title: "Tell Us What You want To Do",
  icon: <FlagOutlined style={{ fontSize: 50 }} />,
  subTitle: "From adventure-packed itineraries to serene getaways, share your vision, and we’ll bring it to life.",
  reviews: "100+ Reviews"
},
{
  title: "Share Your Travel Locations",
  icon: <AimOutlined style={{ fontSize: 50 }} />,
  subTitle: "Whether it’s luxury, adventure, or relaxation, we customize every detail to match your style.",
  reviews: "100+ Reviews"
},
{
  title: "Your Perfect Getaway, Personalized",
  icon: <CommentOutlined style={{ fontSize: 50 }} />,
  subTitle: "Whatever your dream vacation looks like, we specialize in turning it into reality.",
  reviews: "100+ Reviews"
},
{
  title: "Here 100% Trusted Tour Agency",
  icon: <CompassOutlined style={{ fontSize: 50 }} />,
  subTitle: "With over a decade of happy travelers, we’re your trusted partner for seamless, memorable journeys.",
  reviews: "100+ Reviews"
},]

const About = () => {

  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 10000); // Change testimonial every 10 seconds

    return () => clearInterval(interval);
  }, []);

  const { name, position, photo, text } = testimonials[currentIndex];

  return (
    <>
      <div className='aboutUs-banner'>
        <div className='aboutUsBanner'>
          {/* <img src={bannerend} alt='' className='bottomImg' style={{ rotate: "180deg" }} /> */}
          <h1>About Us</h1>
        </div>
      </div>

      <div className='aboutUs-section2'>
        <div className='bg-img'>
          <img src={bgImg} alt='bg-img' />
        </div>
        <Row gutter={[20, 30]}>
          <Col xs={24} sm={24} md={24} lg={1} xl={3}>
          </Col>
          <Col xs={24} sm={24} md={24} lg={11} xl={9} style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
            <h4>Get To Know Us</h4>
            <h2>Explore All Tour of the world with us.</h2>
            <p>At Travelance, we don’t just plan trips—we craft journeys that leave a trail of trance. With over a decade of experience, we’ve delighted countless globetrotters, from corporate teams to adventurous individuals.</p>
            <br />
            <br />
            <p>What sets us apart? Every itinerary we share mirrors the experience you’ll live—seamlessly planned, flawlessly executed. Whether it’s a dreamy getaway or a thrilling adventure, we ensure that what’s promised is exactly what you get.
            </p>
            <br />
            <br />
            <p>So, pack your bags, trust our expertise, and let Travelance turn your travel dreams into reality. Your adventure begins here!
            </p>
            <br />
            <br />
            <Row gutter={[10, 10]}>
              <Col xs={12} sm={8} md={8} lg={8} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <img src={location} alt='' />
                <h6>Destinations
                </h6>
              </Col>
              <Col xs={12} sm={8} md={8} lg={8} style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <img src={bag} alt='' />
                <h6> Tour Guide
                </h6>
              </Col>
              <Col xs={12} sm={8} md={8} lg={8} style={{ display: "flex", alignItems: "center", gap: 10 }} >
                <img src={file} alt='' />
                <h6> Planning
                </h6>
              </Col>
            </Row>
          </Col>
          <Col xs={24} sm={24} md={24} lg={11} xl={9} style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
            <img src={aboutimg} alt='img' width={"100%"} />
          </Col>
          <Col xs={24} sm={24} md={24} lg={1} xl={3}>
          </Col>
        </Row>



      </div>

      <div className='aboutUs-section3'>
        <h4>Core Features</h4>
        <h1><span>Find</span> Travel Perfection</h1>
        <p>Crafting flawless travel experiences tailored to your desires. Your dream journey is just a click away.</p>



        <Row gutter={[20, 30]} style={{ width: "100%" }}>
          {mapping.map((item) =>
            <Col xs={24} sm={24} md={12} lg={6} xl={6} >
              <div class="ag-courses_item">
                <a href="#" class="ag-courses-item_link">
                  <div class="ag-courses-item_bg"></div>

                  <div className='card-icon' style={{ marginBottom: 30 }}>{item.icon}</div>
                  <div class="ag-courses-item_title">
                    {item.title}
                  </div>

                  <div class="ag-courses-item_date-box">
                    <span class="ag-courses-item_date">
                      {item.subTitle}
                    </span>
                  </div>
                  <br />
                  <br />
                  <div class="ag-courses-item_date-box">
                    <span class="ag-courses-item_date" style={{ color: "#176a78" }}>
                      {item.reviews}
                    </span>
                  </div>
                </a>
              </div>
            </Col>
          )}
        </Row>
      </div>

      <div className='aboutUs-section3' style={{ borderTop: "1px solid #176a78", margin: 10 }}>




        <Row gutter={[20, 30]} style={{ width: "100%" }}>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} >
            <h4 style={{ textAlign: "left" }}>Our vision</h4>
            <p style={{ textAlign: "left" }}>To craft tour packages that immerse travelers in the authentic flavors of local communities. By embracing sustainable tourism—be it heritage tourism, ecotourism, or cultural tourism—we create holiday plans that are not only exciting and educational but also beneficial for the environment and local populations.
              <br /> <br />As a travel company, we aim to deliver unforgettable, high-quality travel experiences that align with corporate policies while managing the entire process seamlessly from start to finish.
            </p>
          </Col>
          <Col xs={24} sm={24} md={24} lg={12} xl={12} >
            <h4 style={{ textAlign: "left" }}>Our Mission</h4>
            <p style={{ textAlign: "left" }}>Follow the trail of trance to unforgettable journeys and timeless experiences.
              <br /><br />We are committed to providing exceptional travel experiences, combining superior services, true value for money, and sustainable solutions.
              <br /><br />Our blend of personalized support and innovative technology ensures efficient, professional, and cost-effective travel services tailored to your needs.
            </p>
          </Col>
        </Row>
      </div>


      <div className='aboutUs-section4'>
        <h4>Our Testimonails</h4>
        <h1><span>Good Reviews By </span> Clients</h1>
        <p>Our travelers love us! We’re proud of the unforgettable journeys and seamless experiences we create.</p>

        <Row gutter={[20, 30]}>
          <Col xs={24} sm={24} md={24} lg={2} xl={4}>
          </Col>

          <Col xs={24} sm={24} md={24} lg={10} xl={8} style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
            <img src={aboutimg1} alt='img' width={"100%"} />
          </Col>
          <Col xs={24} sm={24} md={24} lg={10} xl={8} style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
            <div class="testimonial-container">
              <div class="progress-bar"></div>
              <div class="fa fa-quote-right fa-quote">
                <img src={quote2} alt='quote' />
              </div>
              <div class="fa fa-quote-left fa-quote">
                <img src={quote1} alt='quote' />
              </div>
              <p class="testimonial">
                {text}
              </p>
              <div class="user">
                {/* <img src={photo} alt="user" class="user-image" /> */}
                <div class="user-details">
                  <h4 class="username">{name}</h4>
                  <p class="role">{position}</p>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={2} xl={4}>

          </Col>
        </Row>
      </div>

      <LetterPad />

    </>

  )
}

export default About